import '@gohighlevel/ghl-ui/dist/style.css'
import * as Sentry from '@sentry/vue'
import { setupSentry } from 'common/util/setupSentry'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import App from './App.vue'
import { router } from './router'
import './style.css'
import en from '@/locales/en.json'
import da from '@/locales/da.json'
import de from '@/locales/de.json'
import es from '@/locales/es.json'
import fi from '@/locales/fi.json'
import fr_CA from '@/locales/fr-CA.json'
import fr_FR from '@/locales/fr-FR.json'
import it from '@/locales/it.json'
import nl from '@/locales/nl.json'
import no from '@/locales/no.json'
import pt_BR from '@/locales/pt-BR.json'
import pt_PT from '@/locales/pt-PT.json'
import sv from '@/locales/sv.json'

const i18n = createI18n({
  locale: 'en',
  globalInjection: true,
  legacy: false,
  runtimeOnly: true,
  fallbackLocale: 'en',
  messages: {
    en,
    da,
    de,
    es,
    fi,
    fr_CA,
    fr_FR,
    it,
    nl,
    no,
    pt_BR,
    pt_PT,
    sv,
  },
})

const app = createApp(App)
setupSentry(Sentry, app, router, process.env.NODE_ENV as string)
app.use(createPinia())
app.use(i18n)
app.use(router)
app.mount('#app')
